<template>
  <div class="p-6">
    <div class="mb-10">
      <h2>
        {{ $t('CONTENT.charts.liabilityWidgetTitle') }}
        ({{ contractSettingsCurrencyCode }})
      </h2>
      <liability-widget
        :contractId="contractObj.contract.idInDB"
        :currentVersionId="currentVersionId"
        :components="contractObj.assetComponents"
        :allAssets="getAssets"
      />
    </div>
    <div class="mb-10">
      <h2 class="my-4">{{ $t('CONTENT.charts.liabilityChartWidgetTitle') }}</h2>
      <div v-if="contractObj.assetComponents.length > 5">
      <cool-select class = "mb-5"
                   :list="contractObj.assetComponents"
                   option-value="assetId"
                   :custom-text="(assetComponent)=>getAssetName(assetComponent.assetId) + ' Внешний Id: ' + assetComponent.assetExternalId"
                   :placeholder="$t('CONTENT.choose')"
                   v-model="selectedAssetComponent"
      />
        <li
          @click="liabilityActiveTab=`totalLiabilities`"
          class="b-payments__tabs-list-item mr-4"
          :key="`totalLiabilities`"
        >
          <a
            class="b-tabs__list-item-link"
            :class="[ liabilityActiveTab == `totalLiabilities` ? 'router-link-active' : '' ]"
          >Итого активы</a>
        </li>
      </div>
      <ul v-else class="b-tabs__list mb-4">
        <li
          v-for="(component, assetComponentIndex) in contractObj.assetComponents"
          @click="liabilityActiveTab=`${assetComponentIndex}`"
          class="b-payments__tabs-list-item mr-4"
          :key="`${assetComponentIndex}`"
        >
          <a
            class="b-tabs__list-item-link"
            :class="[ liabilityActiveTab == `${assetComponentIndex}` ? 'router-link-active' : '' ]"
          >{{ getAssetName(component.assetId) }} {{ getAssetComponentName(component) }}</a>
        </li>
        <li
          @click="liabilityActiveTab=`totalLiabilities`"
          class="b-payments__tabs-list-item mr-4"
          :key="`totalLiabilities`"
        >
          <a
            class="b-tabs__list-item-link"
            :class="[ liabilityActiveTab == `totalLiabilities` ? 'router-link-active' : '' ]"
          >Итого активы</a>
        </li>
      </ul>
      <div class="b-tabs">
        <liability-chart-widget
          v-if="liabilityActiveTab != `totalLiabilities`"
          :component="contractObj.assetComponents[liabilityActiveTab]"
          :contractId="contractObj.contract.idInDB"
          :current-version-id="currentVersionId"
        />
        <total-liability-chart-widget
          v-if="liabilityActiveTab == `totalLiabilities`"
          :components="contractObj.assetComponents"
          :contractId="contractObj.contract.idInDB"
          :current-version-id="currentVersionId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: ['baseContractObj'],
  data() {
    return {
      liabilityActiveTab: 0,
      contractObj: {},
      selectedAssetComponent: null,
    };
  },
  watch: {
    selectedAssetComponent(value) {
      this.liabilityActiveTab = this.contractObj.assetComponents.indexOf(value)
    },
  },
  created() {
    this.contractObj = this.baseContractObj;
    this.selectedAssetComponent = this.contractObj.assetComponents[0]
  },
  computed: {
    ...mapGetters(["getContractSettings"]),
    ...mapGetters(["getAssets"]),
    contractSettingsCurrencyCode() {
      return this.getContractSettings.currencyCode;
    },
    currentVersionId() {
      if (this.$route.query.eventId) return this.$route.query.eventId;
      else return null;
    },
    assetNames() {
      const assetNames = {}
      this.getAssets.forEach(a => assetNames[a.idInDB] = a.name)
      return assetNames
    }
  },
  methods: {
    getAssetComponentName(component) {
      if (component.name !== null) {
        return ` - ${component.name}`;
      }
    },
    getAssetName(assetId) {
      return this.assetNames[assetId]
    }
  }
};
</script>
